/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Switcher_Reauth_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your session for this organization has expired. Sign in with that organization's account to switch to it." |
*
* @param {Org_Switcher_Reauth_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_switcher_reauth_description = /** @type {((inputs?: Org_Switcher_Reauth_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Switcher_Reauth_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Sitzung für diese Organisation ist abgelaufen. Melde dich mit dem Konto dieser Organisation an, um zu ihr zu wechseln.")
	return /** @type {LocalizedString} */ ("Your session for this organization has expired. Sign in with that organization's account to switch to it.")
});